var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"link-container",attrs:{"href":_vm.source,"target":"_blank","rel":"noopener nofollow"}},[_c('span',{staticClass:"icon",class:`icon-${_vm.icon}`}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }